import React from 'react';
import Link from 'gatsby-link';
import { slugify } from '../components/slugify';
import BackgroundImage from 'react-background-image-loader';
import KontaktMap from '../components/kontakt-map'

// import Img from 'gatsby-image'
var BaseHref = 'http://46.4.51.11:1337'


const KontaktPage = ({ data }) => (
    <div className="about">
        <h1>Kontakt – So finden Sie zu uns </h1>
    


        <div className="row">
            <div className="col-md-8 team_img">
                <div className="col-xs-12" id="KontaktMapContainer">

                    <KontaktMap />

                </div>
            </div>
            <div className="col-md-4" style={{ backgroundColor: '#7092A9', color: '#ffffff', padding: '4em' }}>
                <strong>BOLEY GEOTECHNIK GmbH</strong>
<br/>
Auenstraße 100<br/>
                80469 München<br />
                <br />
                Telefon:	+49 - 89 - 30 90 877 - 0<br />
                Telefax:	+49 - 89 - 30 90 877 - 99<br />
                E-Mail:	<a href="mailto:info@boleygeotechnik.de" style={{color:'#fff', 'text-decoration':'underline'}}>info@boleygeotechnik.de</a><br />
                <br />
                <br />
                Niederlassung Stuttgart<br />
                <br />
                Telefon:	+49 - 7152 - 2 45 66<br />
                E-Mail:	<a href="mailto:stuttgart@boleygeotechnik.de" style={{ color: '#fff', 'text-decoration': 'underline' }}>stuttgart@boleygeotechnik.de</a><br />
 
            </div>
        </div>

        

    </div>

)



export default KontaktPage


export const bueroquery = graphql`  
  query KontaktQuery { 
    strapiAbout {
          id
          Text_ProfBoley
          Text_DrMeier
          Text_Team
          Text_Allg
          buero_slider{
              url
          }
          team_image{
             childImageSharp{
                    sizes {
                    base64
                    tracedSVG
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                    originalImg
                    originalName
                    }
                }
          }
    },
    strapiMetadata{
        placeholder_img{
            childImageSharp{
                sizes {
                base64
                tracedSVG
                aspectRatio
                src
                srcSet
                srcWebp
                srcSetWebp
                sizes
                originalImg
                originalName
                }
            }
        }
    },
        ProjectImgs: allFile (filter:{ internal: {description: {regex: "/uploads/"} } } ) {
            edges{
               node{
                childImageSharp{
                    sizes {
                        src
                    }
                }
                
            }
        }
    }
}
`



// WEBPACK FOOTER //
// ./src/pages/kontakt.js